import React from 'react';

import CardHOC from './Components/CardHOC';
import Integer from '../../Types/Components/Integer';

export default function (props) {
  return <CardHOC question={props.question}>
    <Integer {...props} />
  </CardHOC>
}
